/**
 * Defines a set of themes for the report generator. For now these are hardcoded
 * into the UI. We may eventually move them to the backend.
 */

import { ReportTheme } from './interfaces/report-theme.interface';

export const Themes: Array<ReportTheme> = [
  {
    name: 'Professional',
    slug: 'professional',
    colors: {
      primary: '#0068B3',
      secondary: '#FFC425',
    },
    decorations: {
      portrait: [
        {
          slug: 'header-image',
          width: 100,
          height: 7.62,
          left: 0,
          top: 0,
          data: {
            type: 'url',
            data: '../assets/images/pdf-generator/themes/professional/Header element portrait (primary color).svg',
          },
          themeColor: 'primary',
        },
        {
          slug: 'footer-image',
          width: 7.62,
          height: 15.24,
          left: 0,
          top: 126.76,
          data: {
            type: 'url',
            data: '../assets/images/pdf-generator/themes/professional/Footer element (secondary color).svg',
          },
          themeColor: 'secondary',
        },
      ],
      landscape: [
        {
          slug: 'header-image',
          width: 141.4,
          height: 7.62,
          left: 0,
          top: 0,
          data: {
            type: 'url',
            data: '../assets/images/pdf-generator/themes/professional/Header element landscape (primary color).svg',
          },
          themeColor: 'primary',
        },
        {
          slug: 'footer-image',
          width: 7.62,
          height: 15.24,
          left: 0,
          top: 84.76,
          data: {
            type: 'url',
            data: '../assets/images/pdf-generator/themes/professional/Footer element (secondary color).svg',
          },
          themeColor: 'secondary',
        },
      ],
    },
    overrides: {
      colors: {
        header: '#FFFFFF',
      },
      pageTitle: {
        color: '#FFFFFF',
        date: true,
        sport: true,
        athlete: true,
        coach: true,
        testDisplayId: false,
      },
    },
  },
  {
    name: 'Stark',
    slug: 'stark',
    colors: {
      primary: '#001D1D',
      secondary: '#506D6D',
    },
    decorations: {},
    overrides: {
      colors: {
        header: '#001D1D',
      },
      pageTitle: {
        color: '#001D1D',
      },
    },
  },
];
